import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';

import {
  elRed,
  elGray
} from '../../styles/colors';

export const ButtonGroup = styled(View)`

`;

export const ButtonContainer = styled(View)`

`;

export const AddAttachmentButton = styled(Pressable)`
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px
  width: 80%;
  align-self: center;
  background-color: #fff;
  text-align: center;
`;

export const  DocumentsContainer = styled(View)`
  display: inline-flex;
  flex-direction: row;
  height: fit-content;
  justify-content: space-between;
`;

export const NameColumn = styled(View)`
  display: flex;
  margin-top: 4px;
`;

export const XColumn = styled(View)`
  margin-left: 5px;
`;

export const LinkedAttachmentContainer = styled(View)`
  margin-top: 10px;
`;

export const LinkedAttachmentInnerContainer = styled(View)`
  border: dashed 1px ${elGray};
  border-radius: 5px;
  padding: 10px;
`;

export const LinkedAttachmentTitle = styled(Text)`
  font-size: 16px;
`;

